export interface ConfigurationItem {
    key: string;
    value: () => string;
    type?: string;
    scope?: string;
}

export class ConfigurationService {

    public enforceSuffix = "-enforce";

    private configuration: ConfigurationItem[] = [];


    public addOrUpdate(...configurationItems: Array<ConfigurationItem>) {
        for (let i = 0; i < configurationItems.length; i++) {
            this.remove(configurationItems[i].key, configurationItems[i].scope);
        }
        this.configuration = this.configuration.concat(configurationItems);
    }
    
    public remove(key: string, scope?: string) {
         const idx =  this.configuration.findIndex(x => x.key  == key && x.scope == scope );
         if(idx > -1) this.configuration.splice(idx, 1);
    }

    public getList(type?: string, scope?: string): { [index: string]: string } {
        const result: { [index: string]: string } = {};

        const siteLevelHeaders =
            this.excludeSiteConfiguration(scope) ?
                [] :
                this.configuration.filter(x => x.scope == undefined && x.type == type);

        const scopeLevelHeaders = this.configuration.filter(x => x.type == type && 
            x.scope == this.getScopeName(scope)
        );

        siteLevelHeaders.forEach((element: ConfigurationItem) => {
            result[element.key] = element.value();
        });

        scopeLevelHeaders.forEach((element: ConfigurationItem) => {
            result[element.key] = element.value();
        });

        return result;
    }

    public getByKey(key: string, scope?: string): string {
        if (this.excludeSiteConfiguration(scope)) {
            const result: ConfigurationItem = this.configuration.filter(x => x.key ==key && x.scope == this.getScopeName(scope))[0];
            return (result ? result.value() : null);
        } else {
            let result: ConfigurationItem = this.configuration.filter(x => x.key ==key && x.scope == scope)[0];
            if (!scope && !result) {
                result = this.configuration.filter(x => x.key == key && x.scope == undefined)[0];
            }
            return (result ? result.value() : null);
        }
    }

    private excludeSiteConfiguration(scope?: string): boolean {
        if (scope && scope.endsWith(this.enforceSuffix)) {
            // exclude scope-less configuration, this is a "clean" configuration set
            return true;
        }
        return false;
    }

    private getScopeName(scope?: string): string {
        if (this.excludeSiteConfiguration(scope)) {
            return scope.substring(0, scope.lastIndexOf(this.enforceSuffix));
        }
        return scope;
    }
}